<template>
  <div>
    <div v-if="loading" style="border: 1px solid #F0F0F0">
      <v-progress-circular :width="2" indeterminate style="color: forestgreen"/>
    </div>
    <!--<div v-else style="border: 1px solid #F0F0F0">-->
    <div class="uk-margin-medium-bottom" style="border: 1px solid #F0F0F0">
      <!--Order price only for retoucher role-->
      <div v-if="createFinanceblock && finance_info" class="uk-padding-small">
        <button class="uk-flex uk-flex-middle uk-text-uppercase" type="button">
          <div>
            {{ local_page_keys.label_order_price }}: {{ finance_info.order_price }}
            {{ local_page_keys.label_currency_UAH }}
          </div>
          <span class="material-icons">keyboard_arrow_down</span>
        </button>
        <div class="uk-dropdown" style="padding: 20px;" data-uk-dropdown>
          <div class="uk-grid uk-grid-small uk-child-width-1-1" data-uk-grid>
            <div>
              {{ local_page_keys.label_option_prime_rate }} - {{ finance_info.basic_tarif }}
              {{ local_page_keys.label_currency_UAH }}
            </div>
            <div>
              {{ local_page_keys.label_option_night_order_surcharge }} - {{ finance_info.night_tarif }}
              {{ local_page_keys.label_currency_UAH }}
            </div>
            <div>
              {{ local_page_keys.label_option_day_off_order_surcharge }} - {{ finance_info.weekend_tarif }}
              {{ local_page_keys.label_currency_UAH }}
            </div>
            <div>
              {{ local_page_keys.label_option_additional_features }} - {{ finance_info.additional_services }}
              {{ local_page_keys.label_currency_UAH }}
            </div>
            <div>
              {{ local_page_keys.order_cost_credits }} - {{ finance_info.order_cost_credits }}
            </div>
          </div>
        </div>
      </div>
      <div class="uk-padding-xsmall tm-background-muted">
        <div class="uk-grid uk-grid-small uk-flex-middle" data-uk-grid>
          <div>
            <div class="tm-how-much-orders" :data-uk-tooltip="local_page_keys.label_client_orders_count">
              <span v-if="Number(how_much_orders) && Number(how_much_orders) <= 10">
                {{ how_much_orders }}
              </span>
              <span v-else>
                10+
              </span>
            </div>
          </div>
          <div v-if="Object.keys(facesOrderSuperFunction).length > 0">
<!--            <a href="#" @click="info(facesOrderSuperFunction)" :data-uk-tooltip="facesOrderSuperFunction.RU">-->
              <img class="tm-img-icon" :src="facesOrderSuperFunction.icon" width="30" height="30" alt="" :data-uk-tooltip="facesOrderSuperFunction.RU">
<!--            </a>-->
          </div>
          <div>
            {{ local_page_keys.label_ordering_instructions }}:
          </div>
        </div>
      </div>
      <div class="uk-position-relative">
        <!--список-->
        <div v-if="faces !== null" class="uk-grid tm-grid-divider uk-grid-collapse uk-child-width-1-1 tm-info-list" style="z-index: 20" data-uk-grid>
          <!--общее-->
          <div class="uk-transition-toggle uk-animation-fade uk-position-relative" v-for="(value,index) of  Object.keys(faces)" :key="value.worker" :style="'z-index:' + (Object.keys(faces).length - index)">
            <div class="uk-position-relative">
              <div class="uk-padding-small 1" v-if="value === 0">
                {{ local_page_keys.label_instructions_general }}
              </div>
              <div class="uk-padding-small 2" v-else>
                <div  class="uk-grid uk-grid-small uk-child-width-auto uk-flex-middle" data-uk-grid>
                  <template v-if="permission === 'read'  && getFaceInfo(value).deleted_at === null">
                    <div v-html="getFaceName(value)"></div>
                    <div>
                      <img class="tm-img-icon tm-img-part" src="/img/icons/Users_group.svg" width="30" height="30" alt="" @click="showPhotoDialog()" @mousemove="withFacesVisible()" @mouseleave="withFacesNotVisible()">
                    </div>
                  </template>
                  <template v-else-if="isShowDeleted">
                    <div :class="{'tm-text-line-through':getFaceInfo(value).deleted_at}" v-html="getFaceName(value)" :data-uk-tooltip="'title:' + getTooltipFunctionDateInfo(getFaceInfo(value))"></div>
                    <div>
                      <img class="tm-img-icon tm-img-part" src="/img/icons/Users_group.svg" width="30" height="30" alt="" @click="showPhotoDialog()" @mousemove="withFacesVisible()" @mouseleave="withFacesNotVisible()">
                    </div>
                  </template>
                  <div class="uk-width-expand uk-text-right" v-if="permission !== 'read' && value > 0 ">
                    <a href="#" @click="deleteFace(value)" v-if="faceDeleting !== value && getFaceInfo(value).deleted_at === null">
                      <span class="material-icons uk-text-danger 1" :data-uk-tooltip="local_page_keys.remove_face">clear</span>
                    </a>
                    <a href="#" @click="restoreFace(value)" v-if="faceDeleting !== value && getFaceInfo(value).deleted_at">
                      <span class="material-icons uk-text-danger 1" :data-uk-tooltip="local_page_keys.restore_face">settings_backup_restore</span>
                    </a>
                    <span class="uk-icon uk-spinner" v-if="faceDeleting === value" data-uk-spinner="ratio: 0.6"></span>
                  </div>
                </div>
              </div>
              <!--Список фукнций-->
              <div class="uk-grid tm-grid-divider uk-grid-collapse uk-child-width-1-1 tm-functions-grid" data-uk-grid>
                <!--строка функции-->
                <div v-for="(faceValue, key) of  Object.keys(faces[value])" :key="faceValue.worker" :class="faces[value][faceValue] && ('deleted' in faces[value][faceValue]) && ('added_manually' in faces[value][faceValue]) && faces[value][faceValue]['added_manually'] ? ' tm-added-function uk-animation-fade ' : ''">
                  <div v-if="(faceValue != 'order_super_function' && faceValue != 'order_silver_super_function' && faceValue != 'order_subscription_super_function')">
                    <div v-if="((getFaceInfo(value).deleted_at !== null && isShowDeleted) || getFaceInfo(value).deleted_at === null) && ((faces[value][faceValue]['deleted'] && isShowDeleted) || !faces[value][faceValue]['deleted']) " class="uk-grid uk-grid-collapse uk-grid-divider uk-flex-middle"
                         data-uk-height-match="target: > div > div" data-uk-grid>
                      <div class="uk-width-expand">
                        <div class="uk-grid uk-grid-collapse uk-grid-divider uk-flex-middle tm-functions-grid-row"
                             data-uk-height-match="target: > div > div" data-uk-grid>
                          <!--1 - удаление / восстановление функции-->
                          <template v-if="functionLoading != faces[value][faceValue].name + value && getFaceInfo(value).deleted_at === null && !faces[value][faceValue].payed">
                          <div class="uk-width-auto"
                               v-if="faces[value][faceValue] && faces[value][faceValue]['can_be_deleted'] && faces[value][faceValue]['name'] && permission !== 'read'">
                            <a href="#" @click="removeFunction(value, faces[value][faceValue])">
                              <span class="material-icons uk-text-danger 2"
                                    :data-uk-tooltip="local_page_keys.remove_function">clear</span>
                            </a>
                          </div>
                          <div class="uk-width-auto"
                               v-else-if="faces[value][faceValue] && faces[value][faceValue]['deleted'] && faces[value][faceValue]['name'] && permission !== 'read'">
                            <a href="#" @click="restoreFunction(value, faces[value][faceValue])">
                              <span class="material-icons uk-text-danger 2"
                                    :data-uk-tooltip="local_page_keys.restore_function">settings_backup_restore</span>
                            </a>
                          </div>
                          </template>
                          <span class="uk-icon uk-spinner" v-if="functionLoading === faces[value][faceValue].name + value" data-uk-spinner="ratio: 0.6"></span>
                          <!--2 номер фукнции по-порядку-->
                          <div class="uk-width-auto">
                            <div class="uk-padding-small uk-flex uk-flex-middle">
                              <div class="tm-function-order-num">
                                {{ key + 1 }}
                              </div>
                            </div>
                          </div>
                          <!--3 - иконка-->
                          <div class="uk-width-auto">
                            <div class="uk-padding-small uk-flex uk-flex-middle">
                              <div class="uk-width-1-1">
                                <img v-if="faces[value][faceValue].icon" class="tm-img-icon"
                                     :src="faces[value][faceValue].icon" width="30" height="30" alt="">
                                <img v-else class="tm-img-icon" src="/img/images.png" width="30" height="30" alt="">
                              </div>
                            </div>
                          </div>
                          <!--4 - статусы + название фукнции-->
                          <div class="uk-width-expand"
                               v-if="(faces[value][faceValue].capacity && (isNotEmptyStr(faces[value][faceValue].capacity)) || isNotEmptyStr(faces[value][faceValue].capacity_color)) || (faces[value][faceValue].text && isNotEmptyStr(faces[value][faceValue].text) || faces[value][faceValue].RU)">
                            <div class="uk-flex uk-flex-middle">
                              <div class="uk-grid uk-grid-collapse uk-grid-divider uk-width-1-1 uk-flex-middle"
                                   :class="faces[value][faceValue].example_file && faces[value][faceValue].client_file ? 'uk-child-width-1-1' : 'uk-child-width-auto'"
                                   data-uk-height-match="target: > div > div" data-uk-grid>
                                <!--статус-->
                                <div
                                    v-if="(faces[value][faceValue].capacity && (isNotEmptyStr(faces[value][faceValue].capacity)) || isNotEmptyStr(faces[value][faceValue].capacity_color)) || (faces[value][faceValue].text && isNotEmptyStr(faces[value][faceValue].text))">
                                  <div class="uk-padding-small">
                                    <div class="tm-status"
                                         v-if="(faces[value][faceValue].capacity && (isNotEmptyStr(faces[value][faceValue].capacity)) || isNotEmptyStr(faces[value][faceValue].capacity_color))"
                                         :class="faces[value][faceValue].capacity_color && faces[value][faceValue].capacity_color !== '' && faces[value][faceValue].capacity_color !== 'null' ? faces[value][faceValue].capacity_color : 'tm-status-custom'">

                                        <template v-if="local_page_keys[faces[value][faceValue].capacity]">
                                          {{ local_page_keys[faces[value][faceValue].capacity] }}
                                        </template>
                                      <template v-else>
                                        {{faces[value][faceValue].capacity}}
                                      </template>
                                    </div>
                                    <div class="tm-status-custom"
                                         v-if="!isLink(faces[value][faceValue].text) && faces[value][faceValue].text !== '' ">
                                      {{ faces[value][faceValue].text }}
                                      <span class="material-icons tm-translate-button"
                                            v-if="faces[value][faceValue].text && faces[value][faceValue].text.length > 0"
                                            @click="openGoogleTranslate(faces[value][faceValue].text)">translate</span>
                                    </div>
                                  </div>
                                </div>
                                <!--название функции-->
                                <div class="uk-width-expand" v-if="faces[value][faceValue].RU">
                                  <div
                                      :class="'uk-padding-small uk-flex uk-flex-middle ' + faces[value][faceValue].deleted && faces[value][faceValue].deleted === true && !faces[value][faceValue].payed ? 'tm-text-line-through' : ''"
                                      :data-uk-tooltip="'title:' + getTooltipFunctionDateInfo(faces[value][faceValue])"
                                  >
                                    {{ faces[value][faceValue].RU }}
                                    <span v-if="faces[value][faceValue].multiplier >= 2"
                                          :data-uk-tooltip="'title:' + local_page_keys.multiplier_tooltip"
                                          class="tm-status tm-status-small">
                                      x{{ faces[value][faceValue].multiplier }}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!--5 - Скачать-->
                          <div class="uk-width-auto" v-if="faces[value][faceValue].example_file">
                            <div class="uk-padding-small uk-flex uk-flex-middle">
                              <div v-if="typeof (faces[value][faceValue].example_file) === 'object'" class="uk-width-1-1">
                                <div class="uk-grid uk-grid-small uk-flex-middle uk-flex-center"
                                     v-for="url of  faces[value][faceValue].url_example" :key="url.value">
                                  <div>
                                    <img
                                        class="tm-img-icon tm-img-part"
                                        src="/img/icons/Face/File.svg"
                                        width="30" height="30" alt="">
                                  </div>
                                  <div
                                      v-if="!downloading || (downloading && !downloadingUrl.includes(url)) && downloadingUrl.length == 0">
                                    <a
                                        href="javascript:void(0);"
                                        class="tm-link-underline tm-link-reset 1"
                                        @click="downLoadExamplefile(url, (faceValue + '_example'))">
                                      {{ local_page_keys.label_instructions_button_download }}
                                    </a>
                                  </div>
                                  <div
                                      v-else-if="(downloading && !downloadingUrl.includes(url) && downloadingUrl.length > 0)">
                                    <a
                                        href="javascript:void(0);"
                                        class="tm-link-underline tm-link-reset 2"
                                        @click="showAlert">
                                      {{ local_page_keys.label_instructions_button_download }}
                                    </a>
                                  </div>
                                  <div v-else>
                                    <v-progress-circular
                                        :width="2"
                                        indeterminate
                                        style="color: forestgreen"
                                    ></v-progress-circular>
                                  </div>
                                </div>
                              </div>
                              <div
                                  v-else-if="faces[value][faceValue].example_file && faces[value][faceValue].example_file !== ''"
                                  class="uk-width-1-1">
                                <div class="uk-grid uk-grid-small uk-flex-middle uk-flex-center"
                                     @mouseover="zonephoto( '/img/images.png', faces[value][faceValue].example_file)"
                                     @mouseleave="zonephotoLeave(faces[value][faceValue].example_file)"
                                     style="cursor: pointer">
                                  <div>
                                    <img
                                        class="tm-img-icon tm-img-part"
                                        src="/img/icons/Face/File.svg"
                                        width="30" height="30" alt=""/>
                                  </div>
                                  <div
                                      v-if="!downloading || (downloading && !downloadingUrl.includes(faces[value][faceValue].example_file)) && downloadingUrl.length == 0">
                                    <a
                                        href="javascript:void(0);"
                                        class="tm-link-underline tm-link-reset 3"
                                        @click="downLoadExamplefile(faces[value][faceValue].example_file, (faceValue + '_example'))">
                                      {{ local_page_keys.label_instructions_button_download }}
                                    </a>
                                  </div>
                                  <div
                                      v-else-if="(downloading && !downloadingUrl.includes(faces[value][faceValue].example_file) && downloadingUrl.length > 0)">
                                    <a
                                        href="javascript:void(0);"
                                        class="tm-link-underline tm-link-reset 4"
                                        @click="showAlert">
                                      {{ local_page_keys.label_instructions_button_download }}
                                    </a>
                                  </div>
                                  <div v-else>
                                    <v-progress-circular
                                        :width="2"
                                        indeterminate
                                        style="color: forestgreen"
                                    ></v-progress-circular>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!--6 - Зона-->
                          <div class="uk-width-auto" v-if="faces[value][faceValue].client_file">
                            <div class="uk-padding-small uk-flex uk-flex-middle">
                              <div v-if="typeof (faces[value][faceValue].client_file) === 'object'" class="uk-width-1-1">
                                <div class="uk-grid uk-grid-small uk-flex-middle uk-flex-center"
                                     @mousemove="zonephoto(url)"
                                     @mouseleave="zonephotoLeave()"
                                     style="cursor: pointer"
                                     v-for="url of  faces[value][faceValue].client_file"
                                     :key="url.value">
                                  <div>
                                    <img
                                        class="tm-img-icon tm-img-part"
                                        src="/img/icons/Face/File.svg"
                                        width="30" height="30" alt="">
                                  </div>
                                  <div>
                                    <a
                                        href="javascript:void(0);"
                                        class="tm-link-underline tm-link-reset"
                                        @click="showPhotoDialog(url)">
                                      {{ local_page_keys.label_instructions_area }}
                                    </a>
                                  </div>
                                </div>
                              </div>
                              <div
                                  v-else-if="faces[value][faceValue].client_file && faces[value][faceValue].client_file !== '' && faces[value][faceValue].client_file !== 'url' "
                                  class="uk-width-1-1">
                                <div class="uk-grid uk-grid-small uk-flex-middle uk-flex-center"
                                     @mousemove="zonephoto(faces[value][faceValue].client_file)"
                                     @mouseleave="zonephotoLeave()"
                                     style="cursor: pointer"
                                >
                                  <div>
                                    <img
                                        class="tm-img-icon tm-img-part"
                                        src="/img/icons/Face/File.svg"
                                        width="30" height="30" alt=""
                                    >
                                  </div>
                                  <div>
                                    <a
                                        href="javascript:void(0);"
                                        class="tm-link-underline tm-link-reset"
                                        @click="showPhotoDialog(faces[value][faceValue].client_file)"
                                    >
                                      {{ local_page_keys.label_instructions_area }}
                                    </a>
                                  </div>
                                </div>
                              </div>
                              <div class="uk-width-1-1"
                                   v-if="faces[value][faceValue].client_file && faces[value][faceValue].client_file !== '' && downloadingFunctions.includes(faceValue)">
                                <div class="uk-grid uk-grid-small uk-flex-middle uk-flex-center">

                                  <div>
                                    <img
                                        class="tm-img-icon tm-img-part"
                                        src="/img/icons/Face/File.svg"
                                        width="30" height="30" alt="">
                                  </div>
                                  <div>
                                    <a
                                        :href="faces[value][faceValue].client_file"
                                        target="_blank"
                                        class="tm-link-underline tm-link-reset 1"
                                    >
                                      {{ local_page_keys.label_instructions_button_download }}
                                    </a>
                                  </div>
                                </div>

                              </div>

                            </div>
                          </div>
                          <!--7 - Цветные заметки-->
                          <div class="uk-width-auto"
                               v-if="faces[value][faceValue].color_notes && faces[value][faceValue].color_notes.image">
                            <div class="uk-padding-small uk-flex uk-flex-middle">
                              <div class="uk-grid uk-grid-small uk-flex-middle uk-flex-center"
                                   @mousemove="zonephoto(faces[value][faceValue].color_notes.image)"
                                   @mouseleave="zonephotoLeave()"
                                   style="cursor: pointer"
                              >
                                <div>
                                  <img
                                      class="tm-img-icon tm-img-part"
                                      src="/img/icons/Face/File.svg"
                                      width="30" height="30" alt=""
                                  >
                                </div>
                                <div>
                                  <a
                                      href="javascript:void(0);"
                                      class="tm-link-underline tm-link-reset"
                                      @click="showColorNotesDialog(faces[value][faceValue].color_notes)"
                                  >
                                    {{ local_page_keys.label_instructions_area }}
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!--8 - цена для Светы-->
                        <div class="uk-width-auto" v-if="finance_info && faces[value][faceValue]['price']">
                          <div class="uk-padding-small">
                            {{ faces[value][faceValue]['price'] + ' ' + local_page_keys.label_currency_UAH }}
                          </div>
                        </div>
                      </div>
                      <!--9- инфо-->
                      <div class="uk-width-auto">
                        <div class="uk-padding-small uk-text-center uk-flex uk-flex-middle">
                          <div class="uk-width-1-1">
                            <a href="#" class="md-simple" @click="info(faces[value][faceValue])">
                              <span class="material-icons">feedback</span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!--Блок добавления новой фукнции-->
              <div class="uk-background-muted">
                <div id="add-func" class="tm-padding" v-if="newOrderFunction.face === value && permission !== 'read'">
                  <!--Функция-->
                  <div>
                    <div>
                      {{ local_page_keys.function }}
                    </div>
                    <v-select class="uk-margin-small-top tm-v-select"
                              v-model="newOrderFunction.order_function_id"
                              :options="functionList"
                              label="translated"
                              :reduce="func => func.id"
                              @input="functionSelected"
                              :selectable="option => (!option.group && !Object.keys(faces[value]).includes(option.name)) || (!option.group && !Object.keys(faces[value]).includes(option.name))"
                              :class="(newOrderFunction.errors && newOrderFunction.errors.function ? ' uk-form-danger ' : '')">
                      <template v-slot:option="option">
                        <img v-if="option.icon" :src="option.icon" style="width: 20px; height: 20px; margin-right: 5px"
                             alt="">
                        <span v-if="option.group"><b>{{ option.translated }}</b></span>
                        <span v-else>{{ option.translated }}</span>
                      </template>
                    </v-select>
                  </div>
                  <template v-if="newOrderFunction.order_function && newOrderFunction.order_function.types">
                    <template v-for="(type, keyType) in newOrderFunction.order_function.types">
                      <div :key="keyType">
                        <template v-if="type.name">
                          <!--Усиление-->
                          <div v-if="type.name === 'capacity' && type.additional" class="uk-margin-top">
                            <div>
                              {{ local_page_keys.capacity }}
                            </div>
                            <select
                                :class="'uk-select uk-margin-small-top ' + (newOrderFunction.errors && newOrderFunction.errors.capacity ? ' uk-form-danger ' : '')"
                                v-model="newOrderFunction.capacity">
                              <option :value="capacity" v-for="(capacity, capacityKey) in JSON.parse(type.additional)"
                                      :key="capacityKey">
                                 {{ local_page_keys[capacity] }}
                              </option>
                            </select>
                          </div>
                          <!--Текстовое описаине-->
                          <div v-if="type.name === 'text'" class="uk-margin-top">
                            <div>
                              {{ local_page_keys.instructions }}
                            </div>
                            <textarea :disabled="newOrderFunction.disabled"
                                      :class="'uk-textarea uk-margin-small-top ' + (newOrderFunction.errors && newOrderFunction.errors.text ? ' uk-form-danger ' : '')"
                                      rows="3" v-model="newOrderFunction.text"></textarea>
                          </div>
                          <!--Файлы-->
                          <div v-if="type.name === 'files'" class="uk-margin-top">
                            <div>
                              {{ local_page_keys.files }}
                            </div>
                            <div class="tm-options-radio-items uk-panel-scrollable uk-margin-small-top">
                              <div class="uk-grid uk-grid-small uk-child-width-1-3" data-uk-grid>
                                <template
                                    v-if="newOrderFunction.order_function && newOrderFunction.order_function.elements">
                                  <div v-for="(element, elementKey) in newOrderFunction.order_function.elements"
                                       :key="elementKey">
                                    <div class="uk-position-relative tm-options-radio-item tm-options-radio-img-auto">
                                      <input :id="'radio'+elementKey" :value="element.name" type="radio" name="elements"
                                             v-model="newOrderFunction.files"
                                             class="tm-options-radio uk-radio tm-radio-to-check uk-position-absolute uk-position-top-right">
                                      <label class="uk-display-block" :for="'radio'+elementKey">
                                        <div class="tm-options-radio-img tm-options-radio-img-auto uk-position-relative">
                                          <img :src="element.tiny_image_path">
                                        </div>
                                        <div class="uk-grid uk-grid-collapse uk-flex-middle uk-margin-small-top"
                                             data-uk-grid>
                                          <div class="uk-width-expand">
                                            <a target="_blank" class="uk-link-reset" :href="element.image_path">
                                              {{ local_page_keys.open }}
                                            </a>
                                          </div>
                                          <div class="uk-width-auto">
                                            <a target="_blank" :href="element.image_path">
                                              <i class="md-icon md-icon-font md-theme-default small">launch</i>
                                            </a>
                                          </div>
                                        </div>
                                      </label>
                                    </div>
                                  </div>
                                </template>
                              </div>
                            </div>
                          </div>
                          <div v-if="type.name === 'zone'" class="uk-margin-top">
                            <div class="uk-margin-small-bottom">
                              {{ local_page_keys.zone }}
                            </div>
                            <div data-uk-form-custom="target: true">
                              <input :ref="'zoneNewFile'+value" id="zoneNewFile" type="file" accept="image/*"
                                     @change="selectedFile($event, value)">
                              <input
                                  :class=" (newOrderFunction.errors && newOrderFunction.errors.zone ? ' uk-form-danger ' : '') + 'uk-input uk-form-width-medium '"
                                  type="text"
                                  :placeholder="local_page_keys.choose_file"
                                  disabled>
                              <button class="uk-button uk-button-default uk-button-small-padding" type="button"
                                      tabindex="-1">
                                {{ local_page_keys.select_photo }}
                              </button>
                            </div>
                          </div>
                          <div v-if="type.name === 'color_notes'" class="uk-margin-top">
                            <div class="uk-margin-small-bottom">
                              <button type="button" v-if="!showDialog9"
                                      :class=" (newOrderFunction.errors && newOrderFunction.errors.color_notes ? ' uk-form-danger ' : '') + 'uk-button uk-button-default uk-button-large uk-width-1-1'"
                                      @click="showDialog9 = true">
                                <md-icon class="uk-margin-small-right">mode_edit</md-icon>
                                {{ buttonColorNote }}
                              </button>
                            </div>
                          </div>
                        </template>
                      </div>
                    </template>
                  </template>
                  <!--Кнопки СОХРАНИТЬ и ОТМЕНА-->
                  <div class="uk-margin-top uk-text-right">
                    <button href="#add-func" type="button" class="uk-button uk-button-small-padding uk-button-danger uk-margin-small-right"
                            @click="reject">
                      {{ local_page_keys.cancel }}
                    </button>
                    <button href="#add-func" type="button" class="uk-button uk-button-small-padding uk-button-success"
                            @click="saveFunction">
                      {{ local_page_keys.save }}
                      <span class="uk-icon uk-spinner uk-margin-left" v-if="saveLoading" data-uk-spinner></span>
                    </button>
                  </div>
                </div>
              </div>
              <!--кнопка добавления новой функции-->
              <div class="tm-position-top-left-out" v-if="newOrderFunction.face !== value && permission !== 'read' && getFaceInfo(value).deleted_at === null">
                <button
                  href="#add-func"
                  type="button"
                  class="uk-button uk-button-success tm-button-add-small"
                  @click="newOrderFunction.face = value"
                  :data-uk-tooltip="'title: ' +  local_page_keys.tooltip_create_feature  +  getToolTipContent() + '; offset: 5; pos: left'">
                  <md-icon class="small">add</md-icon>
                </button>
              </div>
            </div>
          </div>
          <!--прилодер при добавлении нового лица-->
          <div class="uk-transition-toggle uk-background-muted uk-text-muted uk-animation-fade" v-if="faceLoading" style="z-index: -1;">
            <div class="uk-padding-small uk-text-center">
              <span class="uk-icon uk-spinner" data-uk-spinner></span>
            </div>
          </div>
        </div>
        <!--Кнопка добавления нового лица-->
        <div class="uk-position-bottom-center" style="z-index: 10; bottom: -39px;" v-if="permission !== 'read' && Object.keys(faces).length < 10">
          <button
            href="#add-func"
            type="button" class="uk-button uk-button-success tm-button-add-face-small"
            :disabled="faceLoading"
            @click="addFace"
            :data-uk-tooltip="'title: ' + local_page_keys.tooltip_create_face +  getToolTipContent('face') + '; offset: 5; pos: left'">
            <md-icon class="small">add_reaction</md-icon>
          </button>
        </div>
      </div>
    </div>
    <!--диалоговое окно "главное фото до with faces"-->
    <md-dialog
        class="tm-gal-dialog"
        :md-active.sync="showDialog10"
        :md-closed="true"
        :md-clicked-outside="true"
        :md-close-on-esc="true">
      <div class="uk-padding uk-position-relative tm-modal-page">
        <a href="#" class="uk-position-top-right tm-dialog-close" @click="showDialog10 = false">
          <span class="material-icons">close</span>
        </a>
        <div class="tm-block-img uk-text-center tm-width-1-1 defore-after-block">
          <div class="tm-block-img uk-text-center tm-width-1-1 defore-after-block">
            <img class="alter-photo"
                 v-if="modal_photo !== null"
                 :src="modal_photo" alt="">
            <img class="alter-photo" v-else src="/img/images.png" alt="">
          </div>
        </div>
        <div  v-if="false && (computedAppVersion.indexOf('1.11.12') > -1 || computedAppVersion.indexOf('1.11.11 (168)') > -1)" class="uk-inline-clip uk-transition-toggle tm-block-img 4">
          <div
              :style="order_photo_before_url_style">

          </div>
          <img v-if="main_photo_before !== null" class="main-photo" :src="main_photo_before" alt="">
          <img v-else src="/img/images.png" class="main-photo" alt="">
        </div>


      </div>
    </md-dialog>
    <!--диалоговое окно c цветными метками-->
    <ColorNotesDialog
        :modalColorNotesData="modalColorNotesData"
        :showDialog11="showDialog11"
        @hide="showDialog11 = false"/>
    <!--Добавление цветных меток-->
    <md-dialog
        class="tm-check-dialog"
        :md-active.sync="showDialog9"
        :md-closed="true"
        :md-clicked-outside="true"
        :md-close-on-esc="true"
        ref="commentPhoto">
      <div class="uk-padding uk-position-relative tm-modal-page">
        <a href="#" class="uk-position-top-right tm-dialog-close" @click="showDialog9 = false"><span
            class="material-icons">close</span></a>
        <comment-photo v-model="fixedPhoto"
                       :src-image="(fixedPhoto.image ) ? fixedPhoto.image : (main_photo_after !== null ? main_photo_after : main_photo_before)"
                       :width="canvasWidth"
                       :height="canvasHeight"
                       :fixedPhoto="fixedPhoto"
                       @image="fixedPhoto.image = $event"
                       @fields="fixedPhoto.fields = $event"
                       @classDisplay="classDisplay = $event"
                       @reset="fixedPhoto.image = $event; fixedPhoto.fields = $event"
                       :key="fixedPhoto.image"
                       @close="showDialog9 = false"
        ></comment-photo>

      </div>
    </md-dialog>
    <!--иифо диалоговое окно-->
    <FunctionInfoDialog
        :name="info_name"
        :text="info_text"
        :video="info_video"
        :show="showDialog"
        :items="items"
        :function_name = "info_function_name"
        :showDialogFaceValue="computedFaceValue"
        @hide="showDialog = false"/>
    <!--диалоговое окно "Галерея примеров"-->
    <FunctionGalleryDialog
        :currentIndex="currentExampleCarouselIndex"
        :parent_function_name="info_function_name"
        :show="showDialog6"
        :items="items"
        :showDialogFaceValue="computedFaceValue"
        @hide="showDialog6 = false"
        @catchOnHide="handleHideEvent"
    />
  </div>
</template>
<script>
import FunctionInfoDialog from "@/pages/Dashboard/Components/Dialogs/FunctionInfoDialog";
import FunctionGalleryDialog from "@/pages/Dashboard/Components/Dialogs/FunctionGalleryDialog";
import DownloadExampleMixin from "@/mixins/DownloadExampleMixin";
import LangMixin from "@/mixins/lang-mixin";
import CommentPhoto from "@/pages/Dashboard/Components/CommentPhoto";
import ColorNotesDialog from "@/pages/Dashboard/Components/Dialogs/ColorNotesDialog";
import convertBase64ToBlob from '../../../../filters/convertBase64ToBlob.js';

export default {
  name: "RetouchersInfoBlock",
  props: {
    resolution: {
      type: Object,
      require: true,
    },
    appVersion: {
      type: String,
      require: true,
    },
    main_photo_before_with_faces: {
      type: String,
      require: true,
    },
    how_much_orders: {
      type: Number,
      require: true,
    },
    order_id: {
      type: Number,
      require: true,
    },
    permission: {
      type: String
    },
    prev_status_order: {
      type: String,
      require: true
    },
    main_photo_after: {
      require: true
    },
    main_photo_before: {
      require: true
    },
    canvasWidth: {
      type: Number,
      require: true
    },
    canvasHeight: {
      type: Number,
      require: true
    },
    archive: {
      type: Boolean,
      default:false
    },
  },
  components: {
    FunctionInfoDialog, FunctionGalleryDialog, CommentPhoto, ColorNotesDialog
  },
  filters: {
    convertBase64ToBlob
  },
  mixins: [DownloadExampleMixin, LangMixin],
  data: () => ({
    createFinanceblock: true,
    loading: true,
    saveLoading: false,
    finance_info: null,
    faces: [],
    showDialog10: false,
    showDialog6: false,
    showDialog: false,
    modal_photo: null,
    info_name: "",
    info_text: "",
    info_video: "",
    info_function_name: "",
    timeMin: 0,
    showDialogFaceValue:{},
    items: [
      {
        src_before: '/img/before.jpg',
        src_after: '/img/after.jpg',
      },
      {
        src_before: '/img/before.jpg',
        src_after: '/img/after.jpg',
      },
      {
        src_before: '/img/before.jpg',
        src_after: '/img/after.jpg',
      },
      {
        src_before: '/img/before.jpg',
        src_after: '/img/after.jpg',
      },
    ],
    proRetouchersFinance: ['svetlanaproretoucher@retoucher.app'],
    statusClass: '',
    baseUrl: '',
    currentExampleCarouselIndex: 0,
    functionList: null,
    newOrderFunctionTemplate: {
      order_function_id: null,
      order_function: null,
      face: null,
      capacity: "",
      text: "",
      files: "",
      zone: "",
      errors: {},
      color_notes: {}
    },
    newOrderFunction: {},
    facesOrderSuperFunction: {},
    getterKey: 0,
    hoverLeaveExample: {},
    staticFunctions: [
      {
        name: 'order_premium_background_retouch',
        category: 'background',
        translated: "Premium background retouch",
        id: 10000001,
        icon: '/img/icons/order_individual_background_retouch.svg',
        pass:
            {
              name: "order_individual_background_retouch",
              text: "Premium background retouch",
              type: "text"
            }
      },
      {
        name: 'order_premium_face_retouch',
        category: 'face',
        translated: "Premium face retouch",
        id: 10000002,
        icon: '/img/icons/order_individual_face_retouch.svg',
        pass:
            {
              name: "order_individual_face_retouch",
              text: "Premium face retouch",
              type: "text"
            }
      },
      {
        name: 'order_premium_body_retouch',
        category: 'body',
        translated: "Premium body retouch",
        id: 10000003,
        icon: '/img/icons/order_body_individual_retouch.svg',
        pass:
            {
              name: "order_body_individual_retouch",
              text: "Premium body retouch",
              type: "text"
            }
      },
    ],
    test: {},
    showDialog9: false,
    fixedPhoto: {
      image: null,
      fields: null,
    },
    classDisplay: '',
    showDialog11: false,
    modalColorNotesData: null,
    faceLoading: false,
    faceDeleting: -1,
    downloadingFunctions: [
      'order_change_background',
      'order_photo_frame',
      'order_individual_retouch',
      'order_swap_faces',
      'order_individual_face_retouch',
      'order_individual_add_object',
      'order_individual_background_retouch',
      'order_body_individual_retouch',
    ],
    functionLoading: -1,
    facesInfo: [],
    isShowDeleted:false
  }),

  methods: {
    handleHideEvent(payload){
      if ('parent_function_obj' in payload && payload.parent_function_obj
          &&  Object.keys( payload.parent_function_obj).length > 0) {
        this.info( payload.parent_function_obj)
      }
    },
    getOrderSuperFunction() {
      let filterKey;
      let filterName;
      const facesObjFiltered = Object.fromEntries(
          Object.entries(this.faces).filter(([key, value]) => {
                let filtered = {};
                ['order_super_function', 'order_silver_super_function','order_subscription_super_function'].forEach(function (name) {
                  if (value.hasOwnProperty(name)) {
                    filterKey = key;
                    filterName = name;
                    filtered = value[name];
                  }
                });
                return Object.keys(filtered).length > 0;
              }
          ));
      if (filterKey in facesObjFiltered && filterName in facesObjFiltered[filterKey]) {
        this.facesOrderSuperFunction = facesObjFiltered[filterKey][filterName];
      }
    },

    async fetchOrderInfoBlock() {
      try {
        await this.$store.dispatch("order/financeBlockForRetoucher", {order_id: this.order_id, archive:this.archive});
        let data = await this.$store.getters['order/financeBlockForRetoucher'];
        /* eslint-disable no-console */
        /* eslint-enable no-console */
        if (data && data.status !== 'error') {
          if (typeof (data) !== 'string') {
            this.$emit('order_cost_credits', data.order_cost_credits);
            let profile = await this.$store.getters['profile/me'];
            if (profile && profile.email && this.proRetouchersFinance.includes(profile.email)) {
              this.finance_info = data.finance_select;
              this.finance_info.order_cost_credits = data.order_cost_credits ? data.order_cost_credits : 0;
            }
            // this.faces = data.order_info_block.order_functions;
          }
          this.loading = false;
          this.$emit('loading', false)
        } else {
          this.createFinanceblock = false;
          this.errors = this.local_page_keys.alert_failed_infoBlock;
          this.loading = false;
          this.$emit('loading', false)
        }
      } catch (e) {
        this.createFinanceblock = false;
        this.loading = false;
        this.$emit('loading', false)
        alert(e);
      }
    },

    async zonephoto(url, example = false) {
      if (example) {
        if (example in this.hoverLeaveExample) delete this.hoverLeaveExample[example];
        let getUrl = await this.downloadImgData(example);
        if (getUrl && 'path_img_tiny' in getUrl && 'path_img_tiny_exists' in getUrl && getUrl.path_img_tiny_exists) {
          url = getUrl.path_img_tiny;
        }
      }
      if (!(example in this.hoverLeaveExample)) {
        if (url) url = url.replace('dl=0', 'raw=1');
        this.$emit('zone_photo', url);
        this.$emit('zone-visible', true);
        this.$emit('after-visible', false);
      }
    },

    zonephotoLeave(example) {
      if (example) this.hoverLeaveExample[example] = true;
      this.$emit('zone_photo', null);
      this.$emit('zone-visible', false);
      this.$emit('after-visible', true);
    },

    withFacesVisible() {
      this.$emit('with-faces-visible', true)
      this.$emit('after-visible', false);
    },

    withFacesNotVisible() {
      this.$emit('with-faces-visible', false)
      this.$emit('after-visible', true);
    },

    showPhotoDialog(url) {
      let redoneUrl = '';
      if (url && typeof (url) === 'string') {
        redoneUrl = url.replace('dl=0', 'raw=1');
      }
      this.modal_photo = (url && redoneUrl !== '') ? redoneUrl : this.main_photo_before_with_faces;
      this.showDialog10 = true;
    },

    showColorNotesDialog(data) {
      this.modalColorNotesData = data
      this.showDialog11 = true;
    },

    showAlert() {
      alert(this.local_page_keys.alert_wait_until_the_previous_files_are_downloaded);
    },

    info(faceValue) {
      this.$nextTick( () => {
        this.showDialogFaceValue = faceValue;
        this.info_name = faceValue.RU;
        this.info_function_name = faceValue.name;
        this.info_text = faceValue.instruction_text;
        this.info_video = faceValue.videos;
        this.items = faceValue.links;
        this.showDialog = true;
      })
    },

    isNotEmptyStr(str) {
      return typeof str == 'string' && str !== '';
    },

    async fetchFunctionsList() {
      let requestData = {
        order_id: this.order_id,
        archive: this.archive
      };
      if (this.permission !== 'read') {
        requestData['with-empty'] = true;
      }
      requestData['with-deleted'] = true;
      this.functionLoading = -1;
      await this.$store.dispatch('order/orderFunctionsBlock', requestData)
      let data = this.$store.getters['order/orderFunctionsBlock'];
      this.faces = typeof data !== 'string' ? data.order_functions : null;
      this.facesInfo =  data.faces_info;
      this.isShowDeleted = data.isShowDeleted;
      this.$emit('faces', this.faces);
      this.$emit('create_activities_buttons', true);
      this.getOrderSuperFunction();
    },

    isLink(data) {
      let str = '';

      if (data && data !== '') {
        str = data;
      }

      return str.includes('.com');
    },
    functionSelected(e) {
      let text = null;
      let selectedFunction = this.functionList.filter((item) => item.id === this.newOrderFunction.order_function_id);
      if (selectedFunction && selectedFunction[0] && selectedFunction[0].pass) {
        text = selectedFunction[0].pass.text ? selectedFunction[0].pass.text : null;
        selectedFunction = this.functionList.filter((item) => item.name === selectedFunction[0].pass.name);
        this.newOrderFunction.order_function_id = selectedFunction[0].id ? selectedFunction[0].id : 0;
      }

      const face = this.newOrderFunction.face;
      const orderFunctionId = this.newOrderFunction.order_function_id;
      this.newFunctionReset();
      this.newOrderFunction.face = face;
      this.newOrderFunction.order_function = selectedFunction && selectedFunction[0] ? selectedFunction[0] : [];
      if (text) {
        this.newOrderFunction.text = text;
        this.newOrderFunction.disabled = true;
      }
      this.newOrderFunction.order_function_id = orderFunctionId;
      // document.getElementById('selectFunction').blur();
    },
    selectedFile(e, key) {
      if (e.target.files && e.target.files.length >= 0) {
        this.newOrderFunction.zone = e.target.files[0];
      }
    },
    async saveFunction() {
      this.saveLoading = true;
      this.newOrderFunction.errors = {};
      if (this.newOrderFunction && this.newOrderFunction.order_function) {
        if (this.newOrderFunction.order_function.types) {
          let types = this.newOrderFunction.order_function.types;
          for (let i = 0; i < types.length; i++) {
            if (types[i] && types[i].name) {
              switch (types[i].name) {
                case "capacity":
                  if (!this.newOrderFunction.capacity) {
                    this.newOrderFunction.errors.capacity = 'error';
                  }
                  break;
                case "files":
                  if (!this.newOrderFunction.files) {
                    this.newOrderFunction.errors.files = 'error';
                  }
                  break;
                case "zone":
                  if (!this.newOrderFunction.zone) {
                    this.newOrderFunction.errors.zone = 'error';
                  }
                  break;
                case "text":
                  if (!this.newOrderFunction.text) {
                    this.newOrderFunction.errors.text = 'error';
                  }
                  break;
                case "color_notes":
                  if (!this.newOrderFunction.color_notes) {
                    this.newOrderFunction.errors.color_notes_image = 'error';
                  }
                  break;
              }
            }
          }
        }
      } else {
        this.newOrderFunction.errors.function = 'error';
      }
      if (this.newOrderFunction.errors && Object.keys(this.newOrderFunction.errors).length > 0) {
        this.saveLoading = false;
        return false;
      }

      let formData = new FormData();
      formData.append('face', this.newOrderFunction.face);
      formData.append('capacity', this.newOrderFunction.capacity);
      formData.append('text', this.newOrderFunction.text);
      formData.append('zone', this.newOrderFunction.zone);
      formData.append('files', this.newOrderFunction.files);
      formData.append('order_function_id', this.newOrderFunction.order_function_id);
      formData.append('order_id', this.order_id);

      if (this.fixedPhoto.image !== null) {
        formData.append('color_notes_image', convertBase64ToBlob(this.fixedPhoto.image));
        formData.append('color_notes_comments', this.fixedPhoto.fields);
      }

      await this.$store.dispatch('order/addFunctionToOrder', formData);
      let result = this.$store.getters['order/addFunctionToOrder'];
      this.saveLoading = false;
      this.newFunctionReset();
      await this.fetchFunctionsList();
    },
    newFunctionReset() {
      this.newOrderFunction = JSON.parse(JSON.stringify(this.newOrderFunctionTemplate));
      this.fixedPhoto.image = null;
      this.fixedPhoto.fields = null;
    },
    async removeFunction(face, orderFunction) {
      if (!orderFunction.can_be_deleted) {
        return;
      }
      if (!confirm(this.local_page_keys.question_remove_function)) {
        return;
      }
      this.functionLoading = orderFunction.name + face;
      let formData = new FormData();
      formData.append('face', face);
      formData.append('order_function_name', orderFunction.name);
      formData.append('order_id', this.order_id);

      await this.$store.dispatch('order/deleteFunctionToOrder', formData);
      let result = this.$store.getters['order/deleteFunctionToOrder'];
      this.newFunctionReset();
      await this.fetchFunctionsList();
    },
    async restoreFunction(face, orderFunction) {
      if (!orderFunction.deleted) {
        return;
      }
      if (!confirm(this.local_page_keys.question_restore_function)) {
        return;
      }
      this.functionLoading = orderFunction.name + face;
      let formData = new FormData();
      formData.append('face', face);
      formData.append('order_function_name', orderFunction.name);
      formData.append('order_id', this.order_id);

      await this.$store.dispatch('order/restoreFunctionToOrder', formData);
      let result = this.$store.getters['order/restoreFunctionToOrder'];
      this.newFunctionReset();
      await this.fetchFunctionsList();
    },
    reject() {
      if (confirm(this.local_page_keys.question_cancel)) {
        this.newFunctionReset();
        this.fixedPhoto.image = null;
        this.fixedPhoto.fields = null;
      }
    },
    replaceFileExtension(filename, newExtension, addDot = true) {
      const dotIndex = filename.lastIndexOf('.');
      if (dotIndex !== -1) {
        const filenameWithoutExtension = filename.substring(0, dotIndex);
        return filenameWithoutExtension + (addDot ? '.' : '') + newExtension;
      }
      return filename; // No extension found, return the original filename
    },
    async downloadImgData(example) {
      await this.$store.dispatch('loading/setLoading', true);
      await this.$store.dispatch("order/downloadExample", 'get_only_links_' + example);
      await this.$store.dispatch('loading/setLoading', false);
      this.getterKey++;
      return await this.$store.getters['order/downloadExample'](this.getterKey);
    },
    async getFunctionList() {
      await this.$store.dispatch('functionsEdit/functionsList');
      let functionList = await this.$store.getters['functionsEdit/functionsList'];
      functionList = functionList.concat(this.staticFunctions);
      const excludeNames = [
        'order_individual_add_object',
        'order_body_individual_retouch',
        'order_individual_background_retouch',
        'order_individual_face_retouch'
      ];
      this.functionList = functionList
          .filter(item => !excludeNames.includes(item.name))
          .sort((a, b) => (a.category > b.category) ? 1 : ((b.category > a.category) ? -1 : 0))
          .reduce(function (total, item, index, array) {
            if (!array[index - 1] || (array[index - 1].category && array[index - 1].category !== item.category)) {
              total.push({
                translated: item.category.toUpperCase(),
                group: true
              })
            }
            total.push(item);
            return total;
          }, []);

    },
    getToolTipContent(type = 'function') {
      let content;
      if (this.prev_status_order === 'hold-admin-new' && type === 'function')
        content = this.local_page_keys.tooltip_for_hold_admin_new;
      else if (this.prev_status_order === 're-done-customer' && type === 'function')
        content = this.local_page_keys.tooltip_for_re_done_customer;
      else if (this.prev_status_order === 're-done-customer' && type === 'face')
        content = this.local_page_keys.tooltip_for_re_done_customer_face;
      else if (this.prev_status_order === 'hold-admin-new' && type === 'face')
        content = this.local_page_keys.tooltip_for_hold_admin_new_face;
      return '<hr class="uk-margin-small">' + content;
    },
    closeDialog() {
      this.showDialog9 = false;
      this.classDisplay = '';
    },
    async addFace() {
      if (this.faces.length >= 10) {
        return;
      }
      this.faceLoading = true;
      let formData = new FormData();
      formData.append('order_id', this.order_id);
      await this.$store.dispatch('order/addFaceToOrder', formData);
      let result = this.$store.getters['order/addFaceToOrder'];
      await this.fetchFunctionsList();
      this.faceLoading = false;
    },
    async deleteFace(face) {
      if (this.faces.length <= 1 && !_.isEmpty(this.faces[face])) {
        return;
      }
      if (!confirm(this.local_page_keys.question_remove_face)) {
        return;
      }
      this.faceDeleting = face;
      let formData = new FormData();
      formData.append('order_id', this.order_id);
      formData.append('face', face);
      await this.$store.dispatch('order/deleteFaceFromOrder', formData);
      let result = this.$store.getters['order/deleteFaceFromOrder'];
      await this.fetchFunctionsList();
      this.faceDeleting = -1;
    },
    async restoreFace(face){
      if (this.faces.length <= 1 && !_.isEmpty(this.faces[face])) {
        return;
      }
      if (!confirm(this.local_page_keys.question_restore_face)) {
        return;
      }
      this.faceDeleting = face;
      let formData = new FormData();
      formData.append('order_id', this.order_id);
      formData.append('face', face);
      await this.$store.dispatch('order/restoreFaceFromOrder', formData);
      let result = this.$store.getters['order/restoreFaceFromOrder'];
      await this.fetchFunctionsList();
      this.faceDeleting = -1;
    },
    getTooltipFunctionDateInfo(orderFunction) {
      let info = '';
      info += this.local_page_keys.created_function_data + ' - ' + orderFunction.created_at;
      info += orderFunction.deleted_at ? '<br>' + this.local_page_keys.deleted_function_data + ' - ' + orderFunction.deleted_at : '';

      return info;
    },
    getFaceName(value) {
      return value > 0 ? this.local_page_keys.label_instructions_face + ' ' + value + ':' : this.local_page_keys.common;
    },
    getFaceInfo(face) {
      return this.facesInfo.find(element => element.face === String(face))
    },
    addBaseUrl(url){
      if (this.isURL(url))
        return url;

      if(url.length > 0 && url[0] != '/') url = '/' + url;
      let host = (process.env.VUE_APP_BASE_URL).replace(/\+$/, '');
      return host + url;
    },
    isURL(str) {
      if(!str)
        return false;

      return str.startsWith('http://') || str.startsWith('https://');
    }
  },
  computed: {
    computedFaceValue(){
      return this.showDialogFaceValue;
    },
    buttonColorNote() {
      return this.fixedPhoto.fields ? this.local_page_keys.show_notes : this.local_page_keys.add_notes;
    },
    computedAppVersion(){
      let app = this.appVersion;
      sessionStorage.setItem('appVersion', '' + app);
      return app;
    },
    order_photo_before_url_style(){

      let style = 'position: absolute;' +
          'background-color: #b62626;' +
          'aspect-ratio: '+this.aspectRatio+';' +
          'bottom: 0;' +
          'top: 50%;' +
          'left: 50%;' +
          'transform: translate(-50%, -50%);' +
          'width: max-content;height: 100%;' +
          'opacity: 0.5;' +
          'background-image: url('+this.addBaseUrl(this.main_photo_before_with_faces)+');' +
          'background-position: 50%;' +
          'background-size: cover;';
      let dim = this.resolution.order_photo_before_url.height > this.resolution.order_photo_before_url.width ? 'height:100%; width: max-content;': 'width:100%; height: max-content;';

      if('order_photo_before_url' in this.resolution
          && 'width' in this.resolution.order_photo_before_url
          && 'height' in this.resolution.order_photo_before_url
          && this.resolution.order_photo_before_url.height / this.resolution.order_photo_before_url.width > 2){

        return style +
            'background-size: 155%;' +
            'background-position-x: calc(50% - -20%);' +
            'background-position-y: calc(50% - 57%);';
      }

      return style + dim;
    },
    aspectRatio(){
      if('order_photo_before_url' in this.resolution
          && 'width' in this.resolution.order_photo_before_url
          && 'height' in this.resolution.order_photo_before_url
      ){
        return ' ' + this.resolution.order_photo_before_url.width + '/' + this.resolution.order_photo_before_url.height;
      }
      return '';
    },
  },
  async created() {
    this.baseUrl = process.env.VUE_APP_API_BASE_URL.replace('api/v1', '');
    await this.fetchOrderInfoBlock();
    await this.fetchFunctionsList();
    await this.getFunctionList();
    this.newFunctionReset();
  },
}
</script>